import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=0c8ba187&scoped=true&"
import script from "./Like.vue?vue&type=script&lang=js&"
export * from "./Like.vue?vue&type=script&lang=js&"
import style0 from "./Like.vue?vue&type=style&index=0&id=0c8ba187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ba187",
  null
  
)

export default component.exports